import moment from "moment";
import AbsenceIcon from "../assets/images/icon_recitation/icon-card/absence.svg";
import AttendanceIcon from "../assets/images/icon_recitation/icon-card/attendance.svg";
import EndSetoranIcon from "../assets/images/icon_recitation/icon-card/end-setoran.svg";
import StartSetoranIcon from "../assets/images/icon_recitation/icon-card/start-setoran.svg";
import TotalSetoranIcon from "../assets/images/icon_recitation/icon-card/total-setoran.svg";
import {
  ChatBubbleBottomCenterTextIcon,
  DocumentTextIcon,
  HeartIcon,
} from "@heroicons/react/20/solid";

import { t } from "i18next";
import { useTranslation } from "react-i18next";

export type Recaptype = {
  createTime: null;
  creatorId: null;
  updateTime: null;
  editorId: null;
  isDelete: boolean;
  deleteBy: null;
  deleteTime: null;
  userId: string;
  startHafalan: string;
  endHafalan: string;
  totalHafalan: string;
  attendance: number;
  absence: number;
  permission?: number;
  izin?: number;
  sick?: number;
  sakit?: number;
  note?: string;
  notes?: string;
  catatan?: string;
  month: number;
  year: number;
  week: number;
  batchId: null;
  teacherId: null;
  companyId: null;
  _id: string;
  studentName: string;
  studentNis: string;
};

type propTypes = {
  data: Recaptype;
};

export const CardRecap = ({ data }: propTypes) => {
  const { i18n } = useTranslation();
  const getWeekRange = (year: number, month: number, week: number) => {
    const firstOfMonth = moment([year, month - 1, 1]);

    const startOfWeek = firstOfMonth
      .clone()
      .add(week - 1, "weeks")
      .startOf("week");
    const endOfWeek = startOfWeek.clone().endOf("week");

    return `${startOfWeek.locale(i18n.language).format("ll")} - ${endOfWeek
      .locale(i18n.language)
      .format("ll")}`;
  };

  const LABEL_HAFALAN: { label: string; icon: any; key: keyof Recaptype }[] = [
    {
      label: t("RECITATION.labelRecap.startHafalan"),
      icon: StartSetoranIcon,
      key: "startHafalan",
    },
    {
      label: t("RECITATION.labelRecap.endHafalan"),
      icon: EndSetoranIcon,
      key: "endHafalan",
    },
    {
      label: t("RECITATION.labelRecap.totalHafalan"),
      icon: TotalSetoranIcon,
      key: "totalHafalan",
    },
    {
      label: t("RECITATION.labelRecap.attendance"),
      icon: AttendanceIcon,
      key: "attendance",
    },
    {
      label: t("RECITATION.labelRecap.absence"),
      icon: AbsenceIcon,
      key: "absence",
    },
  ];

  const permission = data.permission ?? data.izin ?? "-";
  const sick = data.sick ?? data.sakit ?? "-";
  const note = data.note ?? data.notes ?? data.catatan ?? "-";

  return (
    <div className="w-full overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
      <div className="flex items-start justify-between gap-2 border-b border-slate-100 px-3 py-2">
        <div className="text-xs font-semibold text-slate-800">
          {t("RECITATION.filterWeek")} {data.week}
        </div>
        <div className="text-right text-[11px] leading-4 text-slate-400">
          {getWeekRange(data.year, data.month, data.week)}
        </div>
      </div>
      <div className="space-y-2 px-3 py-2.5">
        <div className="space-y-1.5">
          {LABEL_HAFALAN.slice(0, 3).map((item) => (
            <div key={item.key} className="flex items-center gap-2">
              <img src={item.icon} alt="" className="h-4 w-4 shrink-0" />
              <span className="flex-1 text-xs text-slate-600">{item.label}</span>
              <span className="text-xs font-medium text-slate-800">
                {data[item.key] ?? "-"}
              </span>
            </div>
          ))}
        </div>
        <div className="grid grid-cols-2 gap-x-3 gap-y-1.5 border-t border-slate-100 pt-2">
          {LABEL_HAFALAN.slice(3).map((item) => (
            <div key={item.key} className="flex items-center gap-1.5">
              <img src={item.icon} alt="" className="h-4 w-4 shrink-0" />
              <span className="truncate text-[11px] text-slate-600">{item.label}</span>
              <span className="ml-auto text-xs font-medium text-slate-800">
                {data[item.key] ?? "-"}
              </span>
            </div>
          ))}
          <div className="flex items-center gap-1.5">
            <DocumentTextIcon className="h-4 w-4 shrink-0 text-amber-500" />
            <span className="truncate text-[11px] text-slate-600">
              {t("RECITATION.labelRecap.permission")}
            </span>
            <span className="ml-auto text-xs font-medium text-slate-800">{permission}</span>
          </div>
          <div className="flex items-center gap-1.5">
            <HeartIcon className="h-4 w-4 shrink-0 text-rose-500" />
            <span className="truncate text-[11px] text-slate-600">
              {t("RECITATION.labelRecap.sick")}
            </span>
            <span className="ml-auto text-xs font-medium text-slate-800">{sick}</span>
          </div>
        </div>
        <div className="flex items-start gap-1.5 rounded-md bg-slate-50 px-2 py-1.5">
          <ChatBubbleBottomCenterTextIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-slate-500" />
          <p className="min-w-0 break-words text-[11px] leading-4 text-slate-600">
            <span className="font-medium text-slate-700">
              {t("RECITATION.labelRecap.note")}:{" "}
            </span>
            {note}
          </p>
        </div>
      </div>
    </div>
  );
};
